<script lang="ts">
  import { Router } from 'sv-router';
  import './utils/router';
</script>

<Router base="#" />
